import { Injectable } from '@angular/core';
import { ArticleProjectGroupDataService } from '../components/article/manager/article-project-group-data.service';
import { ProjectGroupDataService } from '../components/import-export/service/project-group-data.service';
import { ProjectGroupVO } from '../model/vo/project-group.vo';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProjectGroupService {

  constructor(private articleProjectGroupDataService: ArticleProjectGroupDataService,
              private projectGroupDataService: ProjectGroupDataService,
  ) {
  }

  public saveProjectGroup(isArticleProjectGroup: boolean, projectGroupVO: ProjectGroupVO): Promise<ProjectGroupVO> {
    const observable = isArticleProjectGroup
      ? this.articleProjectGroupDataService.saveArticleProjectGroup(projectGroupVO)
      : this.projectGroupDataService.saveProjectGroup(projectGroupVO);
    return lastValueFrom(observable);
  }

  public loadBaseProjectGroups(isArticleProjectGroup: boolean): Promise<ProjectGroupVO[]> {
    const observable = isArticleProjectGroup ? this.articleProjectGroupDataService.loadBaseArticleProjectGroups()
      : this.projectGroupDataService.loadProjectGroupsOwnedByUser();
    return lastValueFrom(observable);
  }

  public loadProjectGroupById(isArticleProjectGroup: boolean, groupId: number): Promise<ProjectGroupVO> {
    const observable = isArticleProjectGroup ?
      this.articleProjectGroupDataService.loadArticleProjectGroupById(groupId, 1)
      : this.projectGroupDataService.loadProjectGroupById(groupId, 1);
    return lastValueFrom(observable);
  }
}
